import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';

export interface LossReason {
    id: string;
    name: string;
    sortOrder: number;
    active: boolean;
}

export interface LossReasonInput {
    name: string;
    active: boolean;
}

export class LossReasonService extends BaseService {
    protected get resourceName(): string {
        return 'crm/loss-reasons';
    }

    public async list(): Promise<AxiosResponse<{ data: LossReason[] }>> {
        return await this.get('');
    }

    public async create(body: LossReasonInput): Promise<AxiosResponse<{ data: LossReason }>> {
        return await this.post(body);
    }

    public async update(
        id: string,
        body: LossReasonInput
    ): Promise<AxiosResponse<{ data: LossReason }>> {
        return await this.put(id, body);
    }

    public async remove(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }
}
